import React, { Fragment } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import translate from '../../other/translate.json';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';

const CustomRadio = withStyles({
  root: {
    color: '#F6F6FB',
    '&$checked': {
      color: '#EB505E',
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

export default function FilterArchive(props) {
  const classes = useStyles();
  const language = localStorage.getItem('language') || 'Ru';

  const {disabled} = props

  return (
    <React.Fragment>
      <FormControl component="fieldset">
        <RadioGroup aria-label="g" name="g1" value={props.value} onChange={props.handleChange}>
          <FormControlLabel style={{ color: '#8987A2' }} value={1} control={<CustomRadio />} label={translate.Words[`ArchiveNot${language}`]}  />
          <FormControlLabel disabled={props.disabled} style={{ color: '#8987A2' }} value={2} control={<CustomRadio />} label={translate.Words[`Archive${language}`]}  />
          
        </RadioGroup>
      </FormControl>
    </React.Fragment >
  )
}

const useStyles = makeStyles(theme => ({
  header: {
    marginTop: 20,
    marginBottom: 10,
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '28px',
    color: '#24262A'
  },
}))